"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.apply = exports.applyAndMarkWildcardEntities = void 0;
var createUnionSchema_1 = require("./createUnionSchema");
var isObject = function (value) { return !!value && value.constructor === Object; };
var isArray = function (value) { return !!value && value.constructor === Array; };
function isEntityWithId(data) {
    return isObject(data) && typeof data === 'object' && data['id']; // tslint:disable-line
}
var applyAndMarkWildcardEntities = function (obj, viewConfig) {
    var ids = {};
    var stripIds = function (toStrip) {
        if (isEntityWithId(toStrip)) {
            return Object.assign.apply(Object, __spreadArray([{}], Object.keys(toStrip)
                .filter(function (k) {
                if (k === '@id') {
                    if (ids[toStrip[k]]) {
                        throw Error('Multiple @ids with same value');
                    }
                    ids[toStrip[k]] = {
                        id: toStrip.id,
                        entityType: toStrip.entityType,
                    };
                    return false;
                }
                return true;
            })
                .map(function (key) {
                var _a;
                return (_a = {},
                    _a[key] = stripIds(toStrip[key]),
                    _a);
            }), false));
        }
        if (isArray(toStrip) && toStrip instanceof Array) {
            return toStrip.map(function (o) { return stripIds(o); });
        }
        return toStrip;
    };
    var stripped = stripIds(obj);
    var replaceRefs = function (toReplace, isWildcardEntity) {
        var entity = isEntityWithId(toReplace) ? toReplace.entityType : null;
        if (isEntityWithId(toReplace) && !entity) {
            if (toReplace.id === toReplace.processInstanceId) {
                // tslint:disable-line
                toReplace = __assign(__assign({}, toReplace), { entityType: 'ProcessInstance' });
            }
            else if (toReplace.id === toReplace.revision) {
                // tslint:disable-line
                toReplace = __assign(__assign({}, toReplace), { entityType: 'RevInfo' });
            }
            else if (toReplace.id &&
                toReplace['schema'] && // tslint:disable-line
                isWildcardEntity &&
                Object.keys(toReplace).length === 2) {
                // wildcard reference from a GET_MANY fetch. leave it.
                return toReplace;
            }
            else {
                throw new Error("Entity ".concat(JSON.stringify(toReplace), " with no entityType."));
            }
        }
        if (entity && viewConfig && !viewConfig.entities[entity]) {
            throw new Error("Entity \"".concat(JSON.stringify(entity), "\"\n                from ").concat(JSON.stringify(toReplace), " not found in viewconfig."));
        }
        var isWildcardRelationship = function (key) {
            return !viewConfig
                ? false
                : entity && viewConfig.entities[entity].fields[key]
                    ? viewConfig.entities[entity].fields[key].relatedEntity === createUnionSchema_1.WILDCARD_ENTITY
                    : false;
        };
        if (isObject(toReplace)) {
            if (toReplace['@ref']) {
                var ref = ids[toReplace['@ref']];
                if (isWildcardEntity) {
                    return { id: ref.id, schema: ref.entityType };
                }
                return ref.id;
            }
            var unexpandedWildcardRelForKey_1 = function (key) {
                return key.endsWith('Id') &&
                    isWildcardRelationship(key.slice(0, -2)) &&
                    !toReplace[key.slice(0, -2)] &&
                    // return the type for convenience, since we need it!
                    toReplace[key.slice(0, -2) + 'Type'];
            };
            return Object.assign.apply(Object, __spreadArray([{}], Object.keys(toReplace).map(function (key) {
                var _a, _b;
                var value = replaceRefs(toReplace[key], isWildcardRelationship(key));
                return __assign((_a = {}, _a[key] = value, _a), (unexpandedWildcardRelForKey_1(key) && (typeof value === 'number' || typeof value === 'string')
                    ? (_b = {},
                        _b[key.slice(0, -2)] = {
                            id: value,
                            schema: unexpandedWildcardRelForKey_1(key),
                        },
                        _b) : undefined));
            }), false));
        }
        if (isArray(toReplace) && toReplace instanceof Array) {
            return toReplace.map(function (o) { return replaceRefs(o, isWildcardEntity); });
        }
        return toReplace;
    };
    return replaceRefs(stripped, false);
};
exports.applyAndMarkWildcardEntities = applyAndMarkWildcardEntities;
// version which just replaces { @refs } objects with the ids.
// when we apply viewConfig, then we replace them with { id: <id>, schema: <entityType> }
// so that we can denormalize.
var apply = function (obj) { return (0, exports.applyAndMarkWildcardEntities)(obj); };
exports.apply = apply;
//# sourceMappingURL=stripHibernateArtifactsAndReplaceWithIds.js.map